<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Recuperar clave
            <div class="card-actions">
              <button class="btn btn-primary" v-b-tooltip.hover title="Volver al inicio" v-if="!procesando" @click="Inicio()" >
                <i class="icon-arrow-left"></i>
              </button>
            </div>
          </div>
          <div class="card-body">

            <form v-on:submit.prevent="recuperarClave" v-if="procesando == false && error == false && envio_correo == false">
              <h2>Correo electrónico asociado a su cuenta de usuario</h2>
              <hr />

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="correo_electronico">Correo electrónico</label>
                    <b-form-input type="email" :state="validarCorreoElectronico()" v-model="correo_electronico" name="correo_electronico" :disabled="procesando" placeholder="Ingrese correo electrónico"></b-form-input>
                    <b-form-valid-feedback>
                      Correo electrónico válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese un correo electrónico válido. Ej: correo@dominio.com
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <h2>Recuperar clave</h2>
              <hr />

              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <b-button type="button" variant="secondary" style="cursor: not-allowed;" disabled v-if="!validarFormulario ()" v-b-tooltip.hover title="Recuperar clave"><i class="icon-user-following fa-lg"></i></b-button>
                    <b-button type="submit" variant="primary" v-if="validarFormulario ()" v-b-tooltip.hover title="Recuperar clave"><i class="icon-user-following fa-lg"></i></b-button>
                  </b-form-group>
                </b-col>
              </b-row>

            </form>
            <b-alert show class="text-center" variant="info" v-if="procesando == true">
              <b-progress height="20px" :max="100" variant="info" striped :animated="true">
                <b-progress-bar :value="100" :label="'&lt;strong&gt;Procesando...&lt;/strong&gt;'">
                </b-progress-bar>
              </b-progress>
            </b-alert>
            <b-alert show class="text-center" variant="info" v-else-if="procesando == false && error == false && envio_correo == true">
              <h3>Proceso de recuperación de clave</h3>
              {{mensaje_success}}
            </b-alert>
            <b-alert show class="text-center" variant="danger" v-else-if="procesando == false && error == true && envio_correo == false">
              {{mensaje_error}}
            </b-alert>

          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->

  </div>
</template>

<script>
import router from '@/router/index.js'
import usuario from '@/js/usuario.js'

import validationField from 'validationField'

export default {
  name: 'usuario-recuperar-clave',
  mounted () {
    this.envio_correo = false
    this.procesando = false
    this.error = false
  },
  data () {
    return {
      procesando: false,
      error: false,
      envio_correo: false,
      correo_electronico: '',
      mensaje_error: 'Se ha presentado un error en el sistema. Por favor intente más tarde. Si el error continua por favor comuníquese con el administrador del sistema.',
      mensaje_success: 'Se ha envíado un correo para iniciar el proceso de recuperación.'
    }
  },
  methods: {
    validarFormulario () {
      let valido = true

      if (!this.validarCorreoElectronico()) {
        valido = false
      }
      return valido
    },
    validarCorreoElectronico () {
      let valido = true

      if (!this.correo_electronico || !validationField('email', this.correo_electronico)) {
        valido = false
      }
      return valido
    },
    recuperarClave () {
      this.envio_correo = false
      this.procesando = true
      this.error = false

      usuario.recuperar_clave.correo_electronico = this.correo_electronico
      usuario.recuperarClave().then(response => {
        if (response.status === 'success') {
          this.envio_correo = true
          this.procesando = false
          this.error = false
        } else {
          this.envio_correo = false
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    Inicio () {
      router.push({
        name: 'home'
      })
    }
  }

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Usuario/RecuperarClave.vue